<ng-container *ngIf="analysesPaginated; else loadingTpl">
  <div class="gmb-12" *ngFor="let analysis of analysesPaginated">
    <app-analysis-link
      *ngIf="!reportCard; else reportCardTemp"
      [analysis]="analysis"
      [type]="type"
      [showNoResult]="showNoResult"
      [reCheckLabel]="reCheckLabel"
    ></app-analysis-link>
    <ng-template #reportCardTemp>
      <app-analysis-link
        [report]="analysis"
        [type]="type"
        [showNoResult]="showNoResult"
      ></app-analysis-link>
    </ng-template>
  </div>

  <div *ngIf="pageCount > 1" class="d-flex justify-content-center mt-5">
    <ngb-pagination
      [(page)]="page"
      [maxSize]="3"
      [pageSize]="size"
      [boundaryLinks]="true"
      [ellipses]="false"
      [rotate]="true"
      [collectionSize]="collectionSize"
      (pageChange)="pageChanged$.next(null)"
    >
      <ng-template ngbPaginationFirst
        ><i class="gpicon-double-back gpicon-sm"></i
      ></ng-template>
      <ng-template ngbPaginationPrevious
        ><i class="gpicon-back gpicon-lg"></i
      ></ng-template>
      <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
      <ng-template ngbPaginationNext
        ><i class="gpicon-forward gpicon-lg"></i
      ></ng-template>
      <ng-template ngbPaginationLast
        ><i class="gpicon-double-forward gpicon-sm"></i
      ></ng-template>
    </ngb-pagination>
  </div>

  <ng-container *ngIf="analysesPaginated?.length === 0">
    <p class="pt-5 text-center text-secondary">
      {{ 'ANALYSES.NORECS' | translate }}
    </p>
  </ng-container>
</ng-container>

<ng-template #loadingTpl>
  <gpu-loading-spinner-wrapper>
    <gpu-loading-spinner></gpu-loading-spinner>
  </gpu-loading-spinner-wrapper>
</ng-template>
